import { getUserBySlug } from '@api/user'
import { getDate } from '@utils/date'

import type { MessageModelType } from './message.type'

function getUserInfo(slug: string) {
  const { name, avatar } = getUserBySlug(slug)!
  return { slug, name, avatar }
}

export const MESSAGES_LIST: MessageModelType[] = [
  {
    id: 'message-1',
    message: 'Hello Hamza How are you',
    unread: true,
    from: getUserInfo('sebastian-remix-1HJ5J7'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ minutes: -1 }),
  },
  {
    id: 'message-2',
    message: 'Can I Ask you some question',
    unread: false,
    from: getUserInfo('sebastian-remix-1HJ5J7'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ minutes: -1.25 }),
  },
  {
    id: 'message-3',
    message: 'Did you finish the website I gave you Or not',
    unread: false,
    from: getUserInfo('sebastian-remix-1HJ5J7'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ minutes: -1.75 }),
  },
  {
    id: 'message-3-1',
    message: 'Yes I finish it if you have some time please look at it if its Ok',
    unread: false,
    from: getUserInfo('samir-lamir-2D8DC79KD1'),
    to: 'sebastian-remix-1HJ5J7',
    date: getDate({ minutes: -1.75 }),
  },
  {
    id: 'message-3-2',
    message: 'Try to follow the list of review I make If you find something strange or not clear some me a message OK',
    unread: false,
    from: getUserInfo('samir-lamir-2D8DC79KD1'),
    to: 'sebastian-remix-1HJ5J7',
    date: getDate({ minutes: -1.85 }),
  },
  {
    id: 'message-4',
    message: 'OK',
    unread: false,
    from: getUserInfo('sebastian-remix-1HJ5J7'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ minutes: -2 }),
  },
  {
    id: 'message-5',
    message: "After I spend time in refactoring your code I think it's good add prettier and eslint to you code",
    unread: false,
    from: getUserInfo('sebastian-remix-1HJ5J7'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ minutes: -30 }),
  },
  {
    id: 'message-5-1',
    message: 'OK I try to do it know 😁😁😁😁',
    unread: false,
    from: getUserInfo('samir-lamir-2D8DC79KD1'),
    to: 'sebastian-remix-1HJ5J7',
    date: getDate({ minutes: -31 }),
  },
  {
    id: 'message-6',
    message: '👍👍👍👍👍👍👍👍👍👍👍',
    unread: false,
    from: getUserInfo('sebastian-remix-1HJ5J7'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ minutes: -33 }),
  },
  {
    id: 'message-7',
    message: 'Can You Please Send you code Because it time to review it And thanks',
    unread: false,
    from: getUserInfo('sebastian-remix-1HJ5J7'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ days: -1 }),
  },
  {
    id: 'message-8',
    message: 'I Think You need To be fast next time to ship the code early ok 👍👍',
    unread: true,
    from: getUserInfo('sebastian-remix-1HJ5J7'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ days: -1, minutes: -20 }),
  },
  {
    id: 'message-8-1',
    message: 'OK , I am so sorry if Am late Because I try to fix A problem in my Storybook with typescript Sorry',
    unread: true,
    from: getUserInfo('samir-lamir-2D8DC79KD1'),
    to: 'sebastian-remix-1HJ5J7',
    date: getDate({ days: -1, minutes: -42 }),
  },
  {
    id: 'message-9',
    message: 'Ok its not a big deal But only try you best OK',
    unread: true,
    from: getUserInfo('sebastian-remix-1HJ5J7'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ days: -1, minutes: -52 }),
  },
  {
    id: 'message-9-1',
    message: 'Ok its not a big deal But only try you best OK',
    unread: true,
    from: getUserInfo('samir-lamir-2D8DC79KD1'),
    to: 'sebastian-remix-1HJ5J7',
    date: getDate({ days: -1, minutes: -60 }),
  },
  {
    id: 'message-9-2',
    message: 'Next time if I stack in sometimes its not a problem if I ask For help',
    unread: true,
    from: getUserInfo('samir-lamir-2D8DC79KD1'),
    to: 'sebastian-remix-1HJ5J7',
    date: getDate({ days: -1, minutes: -60 }),
  },
  {
    id: 'message-9-3',
    message: '👋👋👋👋👋👋👋👋👋👋👋👋👋',
    unread: true,
    from: getUserInfo('samir-lamir-2D8DC79KD1'),
    to: 'sebastian-remix-1HJ5J7',
    date: getDate({ days: -1, minutes: -80 }),
  },
  {
    id: 'message-10',
    message:
      'Yes , Its not a problem we are all here to learn its not a big deal , Next time if you have a problem ask Kent one of the best developer we have',
    unread: true,
    from: getUserInfo('sebastian-remix-1HJ5J7'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ days: -1, minutes: -92 }),
  },
  {
    id: 'message-11',
    message: "All the stuff you see here is for me don't take it with you",
    unread: true,
    from: getUserInfo('sebastian-remix-1HJ5J7'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ days: -5, minutes: -20 }),
  },
  {
    id: 'message-12',
    message: 'your frind is one the best player in call of ditty',
    unread: true,
    from: getUserInfo('sebastian-remix-1HJ5J7'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ days: -5, minutes: -23 }),
  },
  {
    id: 'message-13',
    message: "All the stuff you see here is for me don't take it with you",
    unread: true,
    from: getUserInfo('sebastian-remix-1HJ5J7'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ years: -0.2 }),
  },
  {
    id: 'message-14',
    message: "All the stuff you see here is for me don't take it with you",
    unread: true,
    from: getUserInfo('sebastian-remix-1HJ5J7'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ days: -22 }),
  },
  {
    id: 'message-15',
    message: "All the stuff you see here is for me don't take it with you",
    unread: true,
    from: getUserInfo('sebastian-remix-1HJ5J7'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ days: -19 }),
  },
  {
    id: 'message-16',
    message: "Don't forget that every monday we play soccer please we are waiting for you",
    unread: true,
    from: getUserInfo('sebastian-remix-1HJ5J7'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ days: -18 }),
  },
  {
    id: 'message-17',
    message: 'your frind is one the best player in call of ditty',
    unread: true,
    from: getUserInfo('sebastian-remix-1HJ5J7'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ days: -17, hours: -13 }),
  },
  {
    id: 'message-18',
    message:
      'Hello , And nice to meet you can you told me where i can find this gift you sand me because my friend girlfriend want it',
    unread: true,
    from: getUserInfo('sebastian-remix-1HJ5J7'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ days: -2, hours: -13 }),
  },
  {
    id: 'message-19',
    message: 'To play soccer in the summer one of the most difficult thing in the word',
    unread: true,
    from: getUserInfo('sebastian-remix-1HJ5J7'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ years: -5 }),
  },
  {
    id: 'message-20',
    message: 'Say Hello to someone every mooring make him happy all together to make the world huppy',
    unread: true,
    from: getUserInfo('sebastian-remix-1HJ5J7'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ days: -32, hours: -13 }),
  },
  {
    id: 'message-21',
    message: 'Form here to there no one can know you better than me',
    unread: true,
    from: getUserInfo('sebastian-remix-1HJ5J7'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ month: -1 }),
  },
  {
    id: 'message-22',
    message: 'To play soccer in the summer one of the most difficult thing in the word',
    unread: true,
    from: getUserInfo('sebastian-remix-1HJ5J7'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ month: -1.123 }),
  },
  {
    id: 'message-23',
    message: 'Did you sand message to Ketty Because she waiting for you',
    unread: true,
    from: getUserInfo('kent-c-dodds-12skj4df34'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ month: -1.11 }),
  },
  {
    id: 'message-24',
    message: "Did you see the last horror movies I don't think that any body can watch it it too scary",
    unread: true,
    from: getUserInfo('kent-c-dodds-12skj4df34'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ days: -17 }),
  },
  {
    id: 'message-25',
    message: 'I figure how i can fix my laptop thanks',
    unread: true,
    from: getUserInfo('kent-c-dodds-12skj4df34'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ hours: -22 }),
  },
  {
    id: 'message-26',
    message: "Did you see the last horror movies I don't think that any body can watch it it too scary",
    unread: true,
    from: getUserInfo('kent-c-dodds-12skj4df34'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ hours: -19 }),
  },
  {
    id: 'message-27',
    message:
      'Hello , And nice to meet you can you told me where i can find this gift you sand me because my friend girlfriend want it',
    unread: true,
    from: getUserInfo('kent-c-dodds-12skj4df34'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ minutes: -22 }),
  },
  {
    id: 'message-28',
    message: 'Say Hello to someone every mooring make him happy all together to make the world huppy',
    unread: true,
    from: getUserInfo('kent-c-dodds-12skj4df34'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ minutes: -14 }),
  },
  {
    id: 'message-29',
    message: "Don't forget that every monday we play soccer please we are waiting for you",
    unread: true,
    from: getUserInfo('kent-c-dodds-12skj4df34'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ minutes: -20 }),
  },
  {
    id: 'message-30',
    message: "All the stuff you see here is for me don't take it with you",
    unread: true,
    from: getUserInfo('kent-c-dodds-12skj4df34'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ month: -1 }),
  },
  {
    id: 'message-31',
    message: 'Every morning i wake up I see you picture in front of my face are you insane',
    unread: true,
    from: getUserInfo('kent-c-dodds-12skj4df34'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ month: -9 }),
  },
  {
    id: 'message-32',
    message: "Don't forget that every monday we play soccer please we are waiting for you",
    unread: true,
    from: getUserInfo('kent-c-dodds-12skj4df34'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ month: -1.5 }),
  },

  // From HEre

  {
    id: 'message-33',
    message: 'Hello hamza Can you please visit me i need you in a project',
    unread: true,
    from: getUserInfo('kent-c-dodds-12skj4df34'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ years: -1 }),
  },

  {
    id: 'message-34',
    message: 'nice to meet you i like your style of code',
    unread: false,
    from: getUserInfo('kent-c-dodds-12skj4df34'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ hours: -2 }),
  },
  {
    id: 'message-35',
    message: 'Did you work with typescript or only javascript please I need your reply as fast as possible',
    unread: false,
    from: getUserInfo('kent-c-dodds-12skj4df34'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ years: -1.25 }),
  },
  {
    id: 'message-36',
    message: 'one of the best friend I ever seen thanks for the help',
    unread: false,
    from: getUserInfo('kent-c-dodds-12skj4df34'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ hours: -1.15 }),
  },
  {
    id: 'message-37',
    message: 'Did you see the last RPG game I like it I think you gonna like it too',
    unread: false,
    from: getUserInfo('kent-c-dodds-12skj4df34'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ minutes: -30 }),
  },
  {
    id: 'message-38',
    message: 'From here to there you never gonna find The biggest gift',
    unread: false,
    from: getUserInfo('kent-c-dodds-12skj4df34'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ days: -45 }),
  },
  {
    id: 'message-39',
    message: 'can You play with me this game i like it',
    unread: false,
    from: getUserInfo('kent-c-dodds-12skj4df34'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ days: -12 }),
  },
  {
    id: 'message-40',
    message: 'did you know the developer how develop this game',
    unread: true,
    from: getUserInfo('kent-c-dodds-12skj4df34'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ days: -18 }),
  },
  {
    id: 'message-41',
    message: 'your frind is one the best player in call of ditty',
    unread: true,
    from: getUserInfo('kent-c-dodds-12skj4df34'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ minutes: -1 }),
  },
  {
    id: 'message-42',
    message: "All the stuff you see here is for me don't take it with you",
    unread: true,
    from: getUserInfo('kent-c-dodds-12skj4df34'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ days: -1 }),
  },
  {
    id: 'message-43',
    message: "All the stuff you see here is for me don't take it with you",
    unread: true,
    from: getUserInfo('kent-c-dodds-12skj4df34'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ days: -0.15 }),
  },
  {
    id: 'message-44',
    message: 'your frind is one the best player in call of ditty',
    unread: true,
    from: getUserInfo('kent-c-dodds-12skj4df34'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ years: -0.02 }),
  },
  {
    id: 'message-45',
    message: "All the stuff you see here is for me don't take it with you",
    unread: true,
    from: getUserInfo('kent-c-dodds-12skj4df34'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ years: -0.2 }),
  },
  {
    id: 'message-46',
    message: "All the stuff you see here is for me don't take it with you",
    unread: true,
    from: getUserInfo('kent-c-dodds-12skj4df34'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ minutes: -22 }),
  },
  {
    id: 'message-47',
    message: "All the stuff you see here is for me don't take it with you",
    unread: true,
    from: getUserInfo('kent-c-dodds-12skj4df34'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ minutes: -19 }),
  },
  {
    id: 'message-48',
    message: "Don't forget that every monday we play soccer please we are waiting for you",
    unread: true,
    from: getUserInfo('kent-c-dodds-12skj4df34'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ minutes: -18 }),
  },
  {
    id: 'message-49',
    message: 'your frind is one the best player in call of ditty',
    unread: true,
    from: getUserInfo('kent-c-dodds-12skj4df34'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ hours: -17 }),
  },
  {
    id: 'message-50',
    message:
      'Hello , And nice to meet you can you told me where i can find this gift you sand me because my friend girlfriend want it',
    unread: true,
    from: getUserInfo('kent-c-dodds-12skj4df34'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ hours: -2 }),
  },
  {
    id: 'message-51',
    message: 'To play soccer in the summer one of the most difficult thing in the word',
    unread: true,
    from: getUserInfo('kent-c-dodds-12skj4df34'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ years: -5 }),
  },
  {
    id: 'message-52',
    message: 'Say Hello to someone every mooring make him happy all together to make the world huppy',
    unread: true,
    from: getUserInfo('kent-c-dodds-12skj4df34'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ hours: -32 }),
  },
  {
    id: 'message-53',
    message: 'Form here to there no one can know you better than me',
    unread: true,
    from: getUserInfo('kent-c-dodds-12skj4df34'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ month: -1 }),
  },
  {
    id: 'message-54',
    message: 'To play soccer in the summer one of the most difficult thing in the word',
    unread: true,
    from: getUserInfo('kent-c-dodds-12skj4df34'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ month: -0.123 }),
  },
  {
    id: 'message-55',
    message: 'Did you sand message to Ketty Because she waiting for you',
    unread: true,
    from: getUserInfo('kent-c-dodds-12skj4df34'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ month: -0.11 }),
  },
  {
    id: 'message-56',
    message: "Did you see the last horror movies I don't think that any body can watch it it too scary",
    unread: true,
    from: getUserInfo('kent-c-dodds-12skj4df34'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ hours: -0.1 }),
  },
  {
    id: 'message-57',
    message: 'I figure how i can fix my laptop thanks',
    unread: true,
    from: getUserInfo('kent-c-dodds-12skj4df34'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ hours: -22 }),
  },
  {
    id: 'message-58',
    message: "Did you see the last horror movies I don't think that any body can watch it it too scary",
    unread: true,
    from: getUserInfo('kent-c-dodds-12skj4df34'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ hours: -19 }),
  },
  {
    id: 'message-59',
    message:
      'Hello , And nice to meet you can you told me where i can find this gift you sand me because my friend girlfriend want it',
    unread: true,
    from: getUserInfo('kent-c-dodds-12skj4df34'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ minutes: -22 }),
  },
  {
    id: 'message-60',
    message: 'Say Hello to someone every mooring make him happy all together to make the world huppy',
    unread: true,
    from: getUserInfo('kent-c-dodds-12skj4df34'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ minutes: -14 }),
  },
  {
    id: 'message-61',
    message: "Don't forget that every monday we play soccer please we are waiting for you",
    unread: true,
    from: getUserInfo('kent-c-dodds-12skj4df34'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ minutes: -20 }),
  },
  {
    id: 'message-62',
    message: "All the stuff you see here is for me don't take it with you",
    unread: true,
    from: getUserInfo('kent-c-dodds-12skj4df34'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ month: -1 }),
  },
  {
    id: 'message-63',
    message: 'Every morning i wake up I see you picture in front of my face are you insane',
    unread: true,
    from: getUserInfo('kent-c-dodds-12skj4df34'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ month: -9 }),
  },
  {
    id: 'message-64',
    message: "Don't forget that every monday we play soccer please we are waiting for you",
    unread: true,
    from: getUserInfo('kent-c-dodds-12skj4df34'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ month: -1.5 }),
  },
  {
    id: 'message-65',
    message: "All the stuff you see here is for me don't take it with you",
    unread: true,
    from: getUserInfo('dan-san-man-12kls56'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ month: -1 }),
  },
  {
    id: 'message-66',
    message: 'Every morning i wake up I see you picture in front of my face are you insane',
    unread: true,
    from: getUserInfo('dan-san-man-12kls56'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ month: -9 }),
  },
  {
    id: 'message-67',
    message: "Don't forget that every monday we play soccer please we are waiting for you",
    unread: true,
    from: getUserInfo('dan-san-man-12kls56'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ month: -1.5 }),
  },
  {
    id: 'message-68',
    message: 'Every morning i wake up I see you picture in front of my face are you insane',
    unread: true,
    from: getUserInfo('dan-san-man-12kls56'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ month: -9 }),
  },
  {
    id: 'message-69',
    message: "Don't forget that every monday we play soccer please we are waiting for you",
    unread: true,
    from: getUserInfo('dan-san-man-12kls56'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ month: -1.5 }),
  },

  {
    id: 'message-70',
    message: 'Say Hello to someone every mooring make him happy all together to make the world huppy',
    unread: true,
    from: getUserInfo('dan-san-man-12kls56'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ minutes: -14 }),
  },
  {
    id: 'message-71',
    message: "Don't forget that every monday we play soccer please we are waiting for you",
    unread: true,
    from: getUserInfo('dan-san-man-12kls56'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ minutes: -20 }),
  },
  {
    id: 'message-72',
    message: "All the stuff you see here is for me don't take it with you",
    unread: true,
    from: getUserInfo('dan-san-man-12kls56'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ month: -1 }),
  },
  {
    id: 'message-73',
    message: 'Every morning i wake up I see you picture in front of my face are you insane',
    unread: true,
    from: getUserInfo('dan-san-man-12kls56'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ month: -9 }),
  },
  {
    id: 'message-74',
    message: "Don't forget that every monday we play soccer please we are waiting for you",
    unread: true,
    from: getUserInfo('dan-san-man-12kls56'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ month: -1.5 }),
  },
  {
    id: 'message-75',
    message: "All the stuff you see here is for me don't take it with you",
    unread: true,
    from: getUserInfo('dan-san-man-12kls56'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ month: -1 }),
  },
  {
    id: 'message-76',
    message: 'Every morning i wake up I see you picture in front of my face are you insane',
    unread: true,
    from: getUserInfo('dan-san-man-12kls56'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ month: -9 }),
  },
  {
    id: 'message-77',
    message: "Don't forget that every monday we play soccer please we are waiting for you",
    unread: true,
    from: getUserInfo('dan-san-man-12kls56'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ month: -1.5 }),
  },
  {
    id: 'message-78',
    message: 'Every morning i wake up I see you picture in front of my face are you insane',
    unread: true,
    from: getUserInfo('dan-san-man-12kls56'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ month: -9 }),
  },
  {
    id: 'message-79',
    message: "Don't forget that every monday we play soccer please we are waiting for you",
    unread: true,
    from: getUserInfo('dan-san-man-12kls56'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ month: -1.5 }),
  },

  {
    id: 'message-80',
    message: 'Say Hello to someone every mooring make him happy all together to make the world huppy',
    unread: true,
    from: getUserInfo('dan-san-man-12kls56'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ minutes: -14 }),
  },
  {
    id: 'message-81',
    message: "Don't forget that every monday we play soccer please we are waiting for you",
    unread: true,
    from: getUserInfo('dan-san-man-12kls56'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ minutes: -20 }),
  },
  {
    id: 'message-82',
    message: "All the stuff you see here is for me don't take it with you",
    unread: true,
    from: getUserInfo('dan-san-man-12kls56'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ month: -1 }),
  },
  {
    id: 'message-83',
    message: 'Every morning i wake up I see you picture in front of my face are you insane',
    unread: true,
    from: getUserInfo('dan-san-man-12kls56'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ month: -9 }),
  },
  {
    id: 'message-84',
    message: "Don't forget that every monday we play soccer please we are waiting for you",
    unread: true,
    from: getUserInfo('dan-san-man-12kls56'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ month: -1.5 }),
  },
  {
    id: 'message-85',
    message: "All the stuff you see here is for me don't take it with you",
    unread: true,
    from: getUserInfo('dan-san-man-12kls56'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ month: -1 }),
  },
  {
    id: 'message-86',
    message: 'Every morning i wake up I see you picture in front of my face are you insane',
    unread: true,
    from: getUserInfo('dan-san-man-12kls56'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ month: -9 }),
  },
  {
    id: 'message-87',
    message: "Don't forget that every monday we play soccer please we are waiting for you",
    unread: true,
    from: getUserInfo('dan-san-man-12kls56'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ month: -1.5 }),
  },
  {
    id: 'message-88',
    message: 'Every morning i wake up I see you picture in front of my face are you insane',
    unread: true,
    from: getUserInfo('dan-san-man-12kls56'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ month: -9 }),
  },
  {
    id: 'message-89',
    message: "Don't forget that every monday we play soccer please we are waiting for you",
    unread: true,
    from: getUserInfo('dan-san-man-12kls56'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ month: -1.5 }),
  },

  {
    id: 'message-90',
    message: 'Say Hello to someone every mooring make him happy all together to make the world huppy',
    unread: true,
    from: getUserInfo('dan-san-man-12kls56'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ minutes: -14 }),
  },
  {
    id: 'message-91',
    message: "Don't forget that every monday we play soccer please we are waiting for you",
    unread: true,
    from: getUserInfo('dan-san-man-12kls56'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ minutes: -20 }),
  },
  {
    id: 'message-92',
    message: "All the stuff you see here is for me don't take it with you",
    unread: true,
    from: getUserInfo('dan-san-man-12kls56'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ month: -1 }),
  },
  {
    id: 'message-93',
    message: 'Every morning i wake up I see you picture in front of my face are you insane',
    unread: true,
    from: getUserInfo('dan-san-man-12kls56'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ month: -9 }),
  },
  {
    id: 'message-94',
    message: "Don't forget that every monday we play soccer please we are waiting for you",
    unread: true,
    from: getUserInfo('dan-san-man-12kls56'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ month: -1.5 }),
  },
  {
    id: 'message-95',
    message: "All the stuff you see here is for me don't take it with you",
    unread: true,
    from: getUserInfo('dan-san-man-12kls56'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ month: -1 }),
  },
  {
    id: 'message-96',
    message: 'Every morning i wake up I see you picture in front of my face are you insane',
    unread: true,
    from: getUserInfo('dan-san-man-12kls56'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ month: -9 }),
  },
  {
    id: 'message-97',
    message: "Don't forget that every monday we play soccer please we are waiting for you",
    unread: true,
    from: getUserInfo('dan-san-man-12kls56'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ month: -1.5 }),
  },
  {
    id: 'message-98',
    message: 'Every morning i wake up I see you picture in front of my face are you insane',
    unread: true,
    from: getUserInfo('dan-san-man-12kls56'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ month: -9 }),
  },
  {
    id: 'message-99',
    message: "Don't forget that every monday we play soccer please we are waiting for you",
    unread: true,
    from: getUserInfo('dan-san-man-12kls56'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ month: -1.5 }),
  },
  {
    id: 'message-100',
    message: "Don't forget that every monday we play soccer please we are waiting for you",
    unread: true,
    from: getUserInfo('dan-san-man-12kls56'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ month: -1.5 }),
  },
  {
    id: 'message-101',
    message: "All the stuff you see here is for me don't take it with you",
    unread: true,
    from: getUserInfo('dan-san-man-12kls56'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ days: -0.15 }),
  },
  {
    id: 'message-102',
    message: 'your frind is one the best player in call of ditty',
    unread: true,
    from: getUserInfo('dan-san-man-12kls56'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ years: -0.02 }),
  },
  {
    id: 'message-103',
    message: "All the stuff you see here is for me don't take it with you",
    unread: true,
    from: getUserInfo('dan-san-man-12kls56'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ years: -0.2 }),
  },
  {
    id: 'message-104',
    message: "All the stuff you see here is for me don't take it with you",
    unread: true,
    from: getUserInfo('dan-san-man-12kls56'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ minutes: -22 }),
  },
  {
    id: 'message-105',
    message: "All the stuff you see here is for me don't take it with you",
    unread: true,
    from: getUserInfo('dan-san-man-12kls56'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ minutes: -19 }),
  },
  {
    id: 'message-106',
    message: "Don't forget that every monday we play soccer please we are waiting for you",
    unread: true,
    from: getUserInfo('dan-san-man-12kls56'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ minutes: -18 }),
  },
  {
    id: 'message-107',
    message: 'your frind is one the best player in call of ditty',
    unread: true,
    from: getUserInfo('ryan-forty-12nbv87'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ hours: -17 }),
  },
  {
    id: 'message-108',
    message:
      'Hello , And nice to meet you can you told me where i can find this gift you sand me because my friend girlfriend want it',
    unread: true,
    from: getUserInfo('ryan-forty-12nbv87'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ hours: -2 }),
  },
  {
    id: 'message-109',
    message: 'To play soccer in the summer one of the most difficult thing in the word',
    unread: true,
    from: getUserInfo('ryan-forty-12nbv87'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ years: -5 }),
  },

  {
    id: 'message-110',
    message: "All the stuff you see here is for me don't take it with you",
    unread: true,
    from: getUserInfo('ryan-forty-12nbv87'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ days: -1 }),
  },
  {
    id: 'message-111',
    message: "All the stuff you see here is for me don't take it with you",
    unread: true,
    from: getUserInfo('ryan-forty-12nbv87'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ days: -0.15 }),
  },
  {
    id: 'message-112',
    message: 'your frind is one the best player in call of ditty',
    unread: true,
    from: getUserInfo('ryan-forty-12nbv87'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ years: -0.02 }),
  },
  {
    id: 'message-113',
    message: "All the stuff you see here is for me don't take it with you",
    unread: true,
    from: getUserInfo('ryan-forty-12nbv87'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ years: -0.2 }),
  },
  {
    id: 'message-114',
    message: "All the stuff you see here is for me don't take it with you",
    unread: true,
    from: getUserInfo('ryan-forty-12nbv87'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ minutes: -22 }),
  },
  {
    id: 'message-115',
    message: "All the stuff you see here is for me don't take it with you",
    unread: true,
    from: getUserInfo('ryan-forty-12nbv87'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ minutes: -19 }),
  },
  {
    id: 'message-116',
    message: "Don't forget that every monday we play soccer please we are waiting for you",
    unread: true,
    from: getUserInfo('ryan-forty-12nbv87'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ minutes: -18 }),
  },
  {
    id: 'message-117',
    message: 'your frind is one the best player in call of ditty',
    unread: true,
    from: getUserInfo('ryan-forty-12nbv87'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ hours: -17 }),
  },
  {
    id: 'message-118',
    message:
      'Hello , And nice to meet you can you told me where i can find this gift you sand me because my friend girlfriend want it',
    unread: true,
    from: getUserInfo('ryan-forty-12nbv87'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ hours: -2 }),
  },
  {
    id: 'message-119',
    message: 'To play soccer in the summer one of the most difficult thing in the word',
    unread: true,
    from: getUserInfo('ryan-forty-12nbv87'),
    to: 'samir-lamir-2D8DC79KD1',
    date: getDate({ years: -5 }),
  },
]
